import "./TreeGenerationStatus.css";

export type GenerationStatus = "VALIDATING" | "QUESTIONS" | "CHAPTERS" | "NODES" | "ERROR" | undefined;

interface TreeGenerationStatusProps {
    status: GenerationStatus;
}

const MESSAGES: Record<Exclude<GenerationStatus, undefined | "ERROR">, string> = {
    VALIDATING: "Validating your materials...",
    QUESTIONS: "Preparing a few questions to personalize your tree...",
    CHAPTERS: "Structuring your course into chapters...",
    NODES: "Building your first practice problems...",
};

/** Shown in place of the tree while a job's tree is still generating (or failed). */
export default function TreeGenerationStatus({ status }: TreeGenerationStatusProps) {
    if (status === "ERROR") {
        return (
            <div className="tree-generation-status" role="status">
                <span className="tree-generation-status__error-icon" aria-hidden="true">
                    <svg viewBox="0 0 38 38" width={48} height={48}>
                        <circle cx="19" cy="19" r="16" fill="none" strokeWidth="3"/>
                        <line x1="19" y1="12" x2="19" y2="21" strokeWidth="2.5" strokeLinecap="round"/>
                        <circle cx="19" cy="26" r="1.7" fill="currentColor"/>
                    </svg>
                </span>
                <p className="tree-generation-status__message">
                    Something went wrong generating this tree.
                </p>
            </div>
        );
    }

    return (
        <div className="tree-generation-status" role="status" aria-live="polite">
            <span className="tree-generation-status__spinner" aria-hidden="true">
                <svg viewBox="0 0 38 38" width={48} height={48}>
                    <circle className="tree-generation-status__spinner-track" cx="19" cy="19" r="16" fill="none"/>
                    <circle className="tree-generation-status__spinner-arc" cx="19" cy="19" r="16" fill="none" strokeLinecap="round"/>
                </svg>
            </span>
            <p className="tree-generation-status__message">
                {(status && MESSAGES[status]) || "Loading your tree..."}
            </p>
        </div>
    );
}
